// eslint-disable-next-line import/prefer-default-export
export const colors = {
  BLUE: ['#72BEDA', '#36A3CA', '#25728D'],
  YELLOW: ['#eea900', '#efa900', '#e29c00'],
  PINK: ['#F4B8B0', '#F4B8B0', '#F29A90'],
};
